module.exports = __webpack_public_path__ + "img/jisukuai3_bg.08a73714.png";